<template>
  <header class="site-header">
    <div class="site-header__top">
      <div class="site-header__container">
        <div class="row">
          <div class="col-8">
            <logo class="site-header__logo" v-if="!isMobile" />
          </div>
          <div class="col-4">
            <site-action class="site-header__action" />
            <site-time class="site-header__time" />
          </div>
        </div>
      </div>
    </div>
    <div class="site-header__end">
      <div class="site-header__container">
        <div class="site-header__nav">
          <logo class="site-header__logo" v-if="isMobile" />

          <site-nav v-if="!isMobile" />

          <div class="site-header__victory">
            <icon name="logo75Victory" height="29" width="113" />
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Logo from './Logo'
import SiteNav from './SiteNav'
import SiteAction from './SiteAction'
import SiteTime from './SiteTime'
import Icon from '../shared/Icon'

export default {
  components: {
    Logo,
    SiteNav,
    SiteAction,
    SiteTime,
    Icon
  },
  computed: {
    isMobile () {
      return this.$mq.resize && this.$mq.below(this.$mv.lg)
    }
  }
}
</script>

<style lang="scss" scoped>
.site-header {
  &__container {
    @include make-container;
    max-width: $container-width-base;
  }

  &__top {
    background: url('../../assets/image/header_bg-sm@2x.jpg') top no-repeat;
    background-size: cover;
    font-family: $font-family-roboto;
    font-weight: 300;
    height: 85px;

    @include media-breakpoint-up(lg) {
      background-image: url('../../assets/image/header_bg@2x.jpg');
      height: 220px;
    }
  }

  &__end {
    background: $theme-red-100;

    @include media-breakpoint-up(lg) {
      height: $header-height;
    }
  }

  &__logo {
    @include media-breakpoint-up(lg) {
      margin-top: 65px;
    }
  }

  &__action {
    margin-top: 25px;

    @include media-breakpoint-down(md) {
      display: none;
    }
  }

  &__time {
    display: none;
    margin-top: 108px;

    @include media-breakpoint-up(lg) {
      display: block;
    }

    @media all and (-ms-high-contrast:none) {
      display: none;
    }
  }

  &__nav {
    align-items: center;
    display: flex;
    height: 50px;

    @include media-breakpoint-up(lg) {
      height: $header-height;
    }
  }

  &__victory {
    display: flex;
    flex-flow: column;
    height: $header-height;
    justify-content: center;

    @include media-breakpoint-up(lg) {
      background-color: $theme-red-200;
      padding: 0 18px;
      margin-left: 15px;
    }
  }
}
</style>
